import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface ComponentProps {
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
}

type Props = ComponentProps;

export default class ConfirmShowFinalizeModal extends React.PureComponent<Props> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Confirm"} autoWidth={true}>
				<div style={{width: "600px"}}>
					<p className={"t-body"}>There is a large buy/sell loss on this order - Please speak to the Operations Manager before continuing.</p>
					<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
					<div className={"pull-right"}>
						<ButtonPrimary label={"Continue"} onClick={this.props.onConfirm}/>
					</div>
				</div>
			</Modal>
		)
	}
}
